import { useIntercom } from 'react-use-intercom'

import { useEffect, useState } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId, selectAuthenticatedUser } from '../../../store/auth/authSlice'
import { useGetMeQuery, useGetUserHashQuery } from '../../../store/user/user'

import { IntegrationServiceId } from '../../../common/integrations'
import { useZocksAuth } from '../../ScopedBlock/hooks'

export const useZocksIntercom = () => {
  const accountId = useAppSelector(selectAccountId)
  const authenticatedUser = useAppSelector(selectAuthenticatedUser)
  const { isOpen, show, boot, hardShutdown, update, hide } = useIntercom()
  const { hasScope } = useZocksAuth()
  const hasUserReadScope = hasScope('**', 'user:read', ['user:admin'])
  const { data: userHash } = useGetUserHashQuery({ accountId: accountId }, { refetchOnMountOrArgChange: true, skip: !hasUserReadScope })
  const { data: userData } = useGetMeQuery({ accountId: accountId }, { refetchOnMountOrArgChange: true, skip: !hasUserReadScope })
  const [booted, setBooted] = useState(false)
  useEffect(() => {
    if (!authenticatedUser) {
      hardShutdown()
      setBooted(false)
    }
  }, [authenticatedUser, hardShutdown])

  useEffect(() => {
    if (!booted && userData && userHash && authenticatedUser && !authenticatedUser?.isGhosted && accountId) {
      const zoomIntegration = userData.integrations?.find((i) => i.serviceId === IntegrationServiceId.ZOOM)

      boot({
        email: userData.email,
        createdAt: userData.createdAt,
        name: userData.me,
        userId: userData.id,
        userHash,
        customAttributes: {
          'Primary user': !authenticatedUser.isCrossAccountUser,
          'Account id': accountId,
          'Has Zoom Integration': !!zoomIntegration?.serviceId,
          'Zoom integration type': zoomIntegration?.configuration.type || '',
          'User roles': userData.roles.map((r) => r.name).join(', '),
        },
      })
      hide()
      setBooted(true)
    }
  }, [booted, userData, userHash, accountId, boot])

  const updateLastRequest = () => {
    if (userData && booted) {
      update({ lastRequestAt: new Date().getTime() / 1000 })
    }
  }

  return {
    isOpen,
    show,
    booted,
    updateLastRequest,
    hide,
    hardShutdown,
  }
}
